// Helpers for tick-all and put-in-order answers (see ListAnswers.tsx).

export type ListOption = { id: string; label: string };

export function readListOptions(
  content: unknown,
  key: 'options' | 'items',
): ListOption[] | null {
  if (typeof content !== 'object' || content === null) return null;
  const list = (content as Record<string, unknown>)[key];
  if (!Array.isArray(list) || list.length < 2) return null;
  const valid = list.filter(
    (entry): entry is ListOption =>
      typeof entry === 'object' &&
      entry !== null &&
      typeof (entry as Record<string, unknown>).id === 'string' &&
      typeof (entry as Record<string, unknown>).label === 'string',
  );
  return valid.length === list.length ? valid : null;
}

export function splitAnswer(value: string): string[] {
  return value.split('\n').filter((id) => id.length > 0);
}
